import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-carbon py-16 md:py-20" aria-labelledby="final-cta-title" data-id="element-38" data-mp="3ucndvrnypfti">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-39" data-mp="c6ivdvtic587">
        <div className="mx-auto max-w-[480px] text-center" data-id="element-40" data-mp="c8byj14ww7bg">
          <h2 id="final-cta-title" className="text-[26px] leading-[1.15] text-ink-light sm:text-[34px]" data-id="element-41" data-mp="84xkuh4g4316">
            ¿Listo para generar{' '}
            <span className="text-gold" data-id="element-42" data-mp="h656nzprzbed">atracción real</span>?
          </h2>
          <p className="mx-auto mt-4 max-w-[400px] text-[12px] font-medium leading-relaxed text-ink-light/60 md:text-[13px]" data-id="element-43" data-mp="h3rd5vaqu78x">
            6 tomos. 5 herramientas adicionales. Un sistema práctico para
            trabajar seguridad, comunicación e intención desde hoy.
          </p>
          <div className="mx-auto mt-7 max-w-[340px]" data-id="element-44" data-mp="14vpqslxo0ep8">
            <CTAButton label="Sí — quiero el Mega Pack completo" data-id="element-45" data-mp="zwv8dl3m0s5n" />
          </div>
          <p className="mt-3 text-[10px] font-medium text-ink-light/50" data-id="element-46" data-mp="2c4wmyl7pu6ft">
            US$19 pago único · Garantía de 7 días · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}